/**
 * RJ tab menu — desktop tabs, Brands/Support dropdowns, mobile drawer sub views.
 * The first tab shown is decided in Liquid (rj-tab-menu-active), so nothing here
 * runs before first paint; this file only handles clicks and keys.
 */
(function () {
  if (window.rjTabMenuReady) return;
  window.rjTabMenuReady = true;

  /* ---------- header height ----------
   * The theme caps the menu at var(--menu-height) (header-hide-menu--active) and
   * measures it only once, so a late font or layout change leaves the tab menu
   * overflowing onto the section below. Re-measure whenever its content resizes.
   */
  function syncMenuHeight() {
    document.querySelectorAll('[data-rj-tabmenu]').forEach(function (menu) {
      if (menu.closest('.header--unpin')) return;
      var h = menu.scrollHeight;
      if (h > 20) document.documentElement.style.setProperty('--menu-height', h + 'px');
    });
  }

  function watchMenuHeight() {
    syncMenuHeight();
    if ('ResizeObserver' in window) {
      var observer = new ResizeObserver(syncMenuHeight);
      document.querySelectorAll('[data-rj-tabmenu] .rj-tabbar, [data-rj-tabmenu] .rj-panel').forEach(function (el) {
        observer.observe(el);
      });
    }
    window.addEventListener('resize', syncMenuHeight, { passive: true });
    window.addEventListener('load', syncMenuHeight, { once: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncMenuHeight);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchMenuHeight);
  } else {
    watchMenuHeight();
  }

  /* ---------- desktop tabs ---------- */
  function selectTab(tab, focus) {
    var root = tab.closest('[data-rj-tabmenu]');
    if (!root) return;
    var index = tab.getAttribute('data-rj-tab');
    root.querySelectorAll('[data-rj-tab]').forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
    root.querySelectorAll('.rj-panel').forEach(function (panel) {
      panel.hidden = panel.id !== 'rj-panel-' + index;
    });
    syncMenuHeight();
    if (focus) tab.focus();
  }

  function closeDropdowns(except) {
    document.querySelectorAll('.rj-dd.is-open').forEach(function (dd) {
      if (dd === except) return;
      dd.classList.remove('is-open');
      var toggle = dd.querySelector('.rj-dd__toggle');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  }

  /* ---------- mobile drawer ---------- */
  function setFooterHidden(hidden) {
    var footer = document.querySelector('.custom-mobile-menu-footer');
    if (footer) footer.classList.toggle('is-hidden', hidden);
  }

  function scrollDrawerTop(from) {
    var drawer = from.closest('#mobile-menu');
    if (!drawer) return;
    drawer.scrollTop = 0;
    var inner = drawer.querySelector('.mobile-menu-drawer--inner');
    if (inner) inner.scrollTop = 0;
  }

  function openSub(mobile, templateId) {
    var tpl = document.getElementById(templateId);
    var sub = mobile.querySelector('[data-rj-m-sub]');
    var root = mobile.querySelector('[data-rj-m-root]');
    if (!tpl || !sub || !root) return;
    sub.replaceChildren(tpl.content.cloneNode(true));
    root.hidden = true;
    sub.hidden = false;
    setFooterHidden(true);
    scrollDrawerTop(mobile);
    var back = sub.querySelector('[data-rj-m-back]');
    if (back) back.focus({ preventScroll: true });
  }

  function closeSub(mobile) {
    var sub = mobile.querySelector('[data-rj-m-sub]');
    var root = mobile.querySelector('[data-rj-m-root]');
    if (!sub || !root || sub.hidden) return;
    sub.hidden = true;
    sub.replaceChildren();
    root.hidden = false;
    setFooterHidden(false);
  }

  function selectMobileTab(button) {
    var mobile = button.closest('[data-rj-mobile]');
    var index = button.getAttribute('data-rj-m-tab');
    mobile.querySelectorAll('[data-rj-m-tab]').forEach(function (b) {
      b.setAttribute('aria-selected', b === button ? 'true' : 'false');
    });
    mobile.querySelectorAll('[data-rj-m-list]').forEach(function (list) {
      list.hidden = list.getAttribute('data-rj-m-list') !== index;
    });
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var target = e.target;

    var tab = target.closest('[data-rj-tab]');
    if (tab) {
      selectTab(tab, false);
      return;
    }

    var ddToggle = target.closest('.rj-dd__toggle');
    if (ddToggle) {
      var dd = ddToggle.parentElement;
      var open = !dd.classList.contains('is-open');
      closeDropdowns(dd);
      dd.classList.toggle('is-open', open);
      ddToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    if (!target.closest('.rj-dd')) closeDropdowns();

    var mTab = target.closest('[data-rj-m-tab]');
    if (mTab) {
      selectMobileTab(mTab);
      return;
    }

    var opener = target.closest('[data-rj-m-open]');
    if (opener) {
      openSub(opener.closest('[data-rj-mobile]'), opener.getAttribute('data-rj-m-open'));
      return;
    }

    var back = target.closest('[data-rj-m-back]');
    if (back) {
      closeSub(back.closest('[data-rj-mobile]'));
      return;
    }

    var grpToggle = target.closest('.rj-m-grp__toggle');
    if (grpToggle) {
      var body = grpToggle.nextElementSibling;
      var expanded = grpToggle.getAttribute('aria-expanded') === 'true';
      grpToggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      if (body) body.hidden = expanded;
    }
  });

  // Arrow keys move between desktop tabs; Escape closes dropdowns.
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDropdowns();
      return;
    }
    var tab = e.target.closest && e.target.closest('[data-rj-tab]');
    if (!tab || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    var tabs = Array.prototype.slice.call(tab.closest('[role="tablist"]').querySelectorAll('[data-rj-tab]'));
    var i = tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
    selectTab(tabs[(i + tabs.length) % tabs.length], true);
    e.preventDefault();
  });

  /* The theme sizes the drawer from --header-offset, which can be stale
   * (e.g. in the theme editor), leaving the drawer taller than the screen and the
   * Email/Call bar cut off. Size it from where it actually starts instead. */
  function fitDrawer() {
    var drawer = document.getElementById('mobile-menu');
    if (!drawer || !drawer.querySelector('[data-rj-mobile]')) return;
    var wrapper = drawer.closest('.mobile-toggle-wrapper');
    if (wrapper && !wrapper.open) return;
    var top = drawer.getBoundingClientRect().top;
    var viewport = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    if (top > 0 && viewport > top) drawer.style.height = Math.floor(viewport - top) + 'px';
  }
  window.addEventListener('resize', fitDrawer, { passive: true });

  // Opening or closing the mobile drawer always starts from the tab lists.
  document.addEventListener('toggle', function (e) {
    if (!e.target.classList || !e.target.classList.contains('mobile-toggle-wrapper')) return;
    document.querySelectorAll('[data-rj-mobile]').forEach(closeSub);
    if (e.target.open) {
      requestAnimationFrame(fitDrawer);
      setTimeout(fitDrawer, 400); // again after the open animation settles
    }
  }, true);

  // Theme editor: selecting an "RJ tab" block shows that tab.
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target.closest && e.target.closest('[data-rj-tab]');
    if (tab) selectTab(tab, false);
  });
})();
